/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createGetEmailStatsResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, type ErrorResponse, type GetEmailStatsResponse, type InternalErrorResponse } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/emails/stats
 */
export interface StatsRequestBuilder extends BaseRequestBuilder<StatsRequestBuilder> {
    /**
     * Counts the organization's emails sent in a window, and how many were delivered, opened, clicked, bounced or marked as spam, in total and day by day. Each email counts once per outcome. Days are counted in the requested time zone and every day in the window is returned, including days with no email. Defaults to the last seven days; the window can be at most 92 days.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<GetEmailStatsResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<StatsRequestBuilderGetQueryParameters> | undefined) : Promise<GetEmailStatsResponse | undefined>;
    /**
     * Counts the organization's emails sent in a window, and how many were delivered, opened, clicked, bounced or marked as spam, in total and day by day. Each email counts once per outcome. Days are counted in the requested time zone and every day in the window is returned, including days with no email. Defaults to the last seven days; the window can be at most 92 days.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<StatsRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * Counts the organization's emails sent in a window, and how many were delivered, opened, clicked, bounced or marked as spam, in total and day by day. Each email counts once per outcome. Days are counted in the requested time zone and every day in the window is returned, including days with no email. Defaults to the last seven days; the window can be at most 92 days.
 */
export interface StatsRequestBuilderGetQueryParameters {
    /**
     * Start of the window (inclusive). Defaults, with To, to the last seven days in TimeZone.
     */
    from?: Date;
    /**
     * Only emails about this kind of record: order, invoice, tearsheet, cart-share, cart-review, company-docs, access-request, api-access, user, sales-rep or organization-signup.
     */
    kind?: string;
    /**
     * IANA time zone the days are counted in, e.g. America/New_York. Defaults to UTC; an unknown zone falls back to UTC.
     */
    timeZone?: string;
    /**
     * End of the window (exclusive). At most 92 days after From.
     */
    to?: Date;
}
/**
 * Uri template for the request builder.
 */
export const StatsRequestBuilderUriTemplate = "{+baseurl}/api/emails/stats{?from*,kind*,timeZone*,to*}";
/**
 * Metadata for all the requests in the request builder.
 */
export const StatsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: StatsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createGetEmailStatsResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
